interface propTypes {
  children: any;
  title: string;
}

const ModalLayout = ({ children, title }: propTypes) => {
  return (
    <div className="fixed left-0 top-0 z-50 flex h-full min-h-screen w-full items-start justify-center bg-black/90 px-4 py-5 overflow-y-auto">
      <div className="w-full lg:max-w-[50%] md:max-w-[70%] sm:max-w-[80%]   rounded-lg bg-white px-8 py-12 dark:bg-dark md:px-12.5 md:py-10 min-h-[200px]">
        <h3 className="pb-2 text-xl font-bold text-black dark:text-white sm:text-2xl">
          {title}
        </h3>
        {children}
      </div>
    </div>
  );
};

export default ModalLayout;
